import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";
import { StatusCell } from "@/components/status/cell";

export default function CategoryQuestions() {

    const columns = [
        {
            id: "question",
            header: "Question",
            accessorKey: "question",
            sortable: true,
        },
        {
            id: "category.name",
            header: "Category",
            accessorKey: "category.name",
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
    ];

    const fields = ["id", "question", "status", "category.name"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="survey_questions"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Question</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Survey Categories Questions"
                    endPoint="survey_questions"
                    columns={columns}
                    meta={{
                        fields,
                    }}
                    sortBy="question"
                    sortOrder="aesc"
                    href={(item) => item.id}
                />
            </div>
        </div>
    );
}
